import apiConfig from '../Data/Api/config';

export const CLOUDFRONT_ASSET_HOST = 'd15eixcc3515pq.cloudfront.net';

const ALLOWED_PATH_PREFIXES = [
    '/Assets/',
    '/live/images/',
];

const createAnchor = (url) => {
    if (!url || typeof document === 'undefined') return null;
    const anchor = document.createElement('a');
    anchor.href = url;
    return anchor;
};

const getPathname = (anchor) => {
    if (!anchor || !anchor.pathname) return '';
    return anchor.pathname.charAt(0) === '/' ? anchor.pathname : '/' + anchor.pathname;
};

export const isCloudfrontAssetUrl = (url) => {
    try {
        const anchor = createAnchor(url);
        if (!anchor) return false;
        const hostname = (anchor.hostname || '').toLowerCase();
        const pathname = getPathname(anchor);
        return anchor.protocol === 'https:' &&
            hostname === CLOUDFRONT_ASSET_HOST &&
            ALLOWED_PATH_PREFIXES.some(prefix => pathname.indexOf(prefix) === 0);
    } catch (err) {
        return false;
    }
};

export const getCloudfrontProxyUrl = (url) => {
    if (!isCloudfrontAssetUrl(url)) return url;
    return apiConfig.url + apiConfig.eCLOUDFRONT_ASSET_PROXY + '?url=' + encodeURIComponent(url);
};
